<template>
    <b-modal ref="downloadbackupmodal" lazy title="Download Backup Part Files" @shown="setDownloadLinks">
        <div class="prompt-text">
            The Backup of the site splitted into more files you can download the part files here.
        </div>
        <div class="backup-parts">
            <div class="download-links">
                <div v-for="(downloadLink,index) in downloadLinks" :key="index" class="text-center" style="    padding: 4px;">
                    <a :href="downloadLink">Download Part - {{index}}</a>
                </div>
            </div>
        </div>
        <div slot="modal-footer" class="w-100">
            <div class="float-right">
                Size: {{backup?backup.size:0}}
                <b-btn variant="primary" @click="downloadAll">
                    Download All Files
                </b-btn>
            </div>
        </div>
    </b-modal>
</template>

<script>
import _ from "lodash";
export default {
  name: "downloadbackup",
  props: ["backup"],
  data() {
    return {
      downloadLinks: []
    };
  },
  methods: {
    setDownloadLinks() {
      this.downloadLinks = _.values(this.backup.downloadURL);
    },
    close() {
      this.$refs.downloadbackupmodal.hide();
    },
    downloadAll() {},
    downloadPartFile() {}
  }
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/modals/DownloadBackup.vue